<template>
	<div id="app">
		<v-app ref="app">
			<Header v-if="!hideHeader" ref="header"></Header>
			<v-main>
				<router-view class="box-container elevation-7" />
			</v-main>
			<Footer v-if="!hideFooter"></Footer>
		</v-app>
	</div>
</template>

<script>
	import Header from "./components/Header";
	import Footer from "./components/Footer";

	export default {
		components: {
			Header: Header,
			Footer: Footer,
		},
		data () {
			return {
				hideHeader: false,
				hideFooter: false
			}
		},
		watch: {
			$route (to, from) {
				this.hideHeader = to.meta.hideHeader
				this.hideFooter = to.meta.hideFooter
				document.title = to.meta.title || "OTSTCFQ";
			},
		},
		mounted () {
			document.title = this.$route.meta.title || "OTSTCFQ";
		},
	};
</script>

<style lang="scss">
	@import "./sass/main.scss";
</style>